import { render } from "./AddEmployeeToWorkShift.vue?vue&type=template&id=a9f6703e"
import script from "./AddEmployeeToWorkShift.vue?vue&type=script&lang=js"
export * from "./AddEmployeeToWorkShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__